export const state = {
    enabled: null,
    alwaysOn: null,
    libraryCleanPending: null,
    cleanLibrary: null,
    host: [],
    username: null,
    password: null,
    notifyOnSnatch: null,
    notifyOnDownload: null,
    notifyOnSubtitleDownload: null,
    update: {
        library: null,
        full: null,
        onlyFirst: null
    }
};

export const mutations = {};

export const getters = {};

export const actions = {};

export default {
    state,
    mutations,
    getters,
    actions
};
